import { render, staticRenderFns } from "./kdxImageVideo.g.vue?vue&type=template&id=7aec804a&scoped=true"
import script from "./kdxImageVideo.g.vue?vue&type=script&lang=js"
export * from "./kdxImageVideo.g.vue?vue&type=script&lang=js"
import style0 from "./kdxImageVideo.g.vue?vue&type=style&index=0&id=7aec804a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aec804a",
  null
  
)

export default component.exports